import { BsPencil, BsPlusCircle } from 'react-icons/bs';
import { FailedToGetData, H2, HorizontalSelector, Loading } from 'src/components/_commons';
import { helpers, publicMinistryServices, userServices } from 'src/services';
import { months } from '@monorepo/helpers';
import { PublicMinistryByCalendar } from './subcomponents/PublicMinistryByCalendar';
import { PublicMinistryByDate } from './subcomponents/PublicMinistryByDate';
import { PublicMinistryByType } from './subcomponents/PublicMinistryByType';
import { PublicMinistryCrud } from './subcomponents/PublicMinistryCrud';
import { PublicMinistryRadio, typeOption } from './subcomponents/PublicMinistryRadio';
import { PublicMinistryServiceRecordButton } from './subcomponents/PublicMinistryServiceRecordButton';
import { setAlertResponse } from 'src/store';
import { typePublicMinistryDoc, typePublicMinistryMonthlyService, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';

export const AdminsPublicMinistry = () => {
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [monthlyServiceToEdit, setMonthlyServiceToEdit] = useState<typePublicMinistryMonthlyService | null>(null);
    const [publicMinistryDoc, setPublicMinistryDoc] = useState<typePublicMinistryDoc | null>(null);
    const [radioValue, setRadioValue] = useState<typeOption>('byType');
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showCrud, setShowCrud] = useState(false);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const monthlyService: typePublicMinistryMonthlyService | null = useMemo(() =>
        publicMinistryDoc?.monthlyServices.find(s =>
            s.year === selectedDate.getFullYear() && s.month === selectedDate.getMonth()
        ) ?? null
    , [publicMinistryDoc, selectedDate]);

    useEffect(() => {
        // setIsLoading1(true);
        publicMinistryServices.Get().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.publicMinistryDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setPublicMinistryDoc(response.data.publicMinistryDoc);
        });
    }, [refreshCounter]);

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        });
    }, []);

    if (isLoading1 || isLoading2) {
        return <Loading mt={'80px'} />;
    }

    if (!publicMinistryDoc || !users) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'SALIDAS DE PREDICACIÓN'} />
        <PublicMinistryServiceRecordButton
            publicMinistryDoc={publicMinistryDoc}
        />
        {!showCrud &&
            <>
            <HorizontalSelector
                label={`${months[selectedDate.getMonth()].toUpperCase()} ${selectedDate.getFullYear()}`}
                setNext={() => {
                    const nextMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
                    setSelectedDate(nextMonth);
                }}
                setPrevious={() => {
                    const prevMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1);
                    setSelectedDate(prevMonth);
                }}
            />
            {monthlyService ?
                <div className={isDarkMode ? 'text-white' : ''}>
                    <div className={'text-center mt-4'}>
                        <button className={'btn btn-general-red'}
                            onClick={() => {
                                setMonthlyServiceToEdit(monthlyService);
                                setShowCrud(true);
                            }}
                        >
                            <BsPencil className={'mb-1 me-2'} />Editar Salidas de {months[selectedDate.getMonth()]}
                        </button>
                    </div>
                    <PublicMinistryRadio
                        radioValue={radioValue}
                        setRadioValue={setRadioValue}
                    />
                    {radioValue === 'byType' ?
                        <PublicMinistryByType
                            monthlyService={monthlyService}
                            publicMinistryDoc={publicMinistryDoc}
                            readOnly
                            setMonthlyService={() => {}}
                            users={users}
                        />
                        :
                        radioValue === 'byDate' ?
                            <PublicMinistryByDate
                                monthlyService={monthlyService}
                            />
                            :
                            <PublicMinistryByCalendar
                                monthlyService={monthlyService}
                            />
                    }
                </div>
                :
                <div className={'text-center mt-4'}>
                    <button className={'btn btn-general-red'} onClick={() => setShowCrud(true)}>
                        <BsPlusCircle className={'mb-1 me-2'} />Crear Salidas de {months[selectedDate.getMonth()]}
                    </button>
                </div>
            }
            </>
        }

        {showCrud &&
            <PublicMinistryCrud
                closeCrud={(update: boolean) => {
                    setShowCrud(false);
                    setMonthlyServiceToEdit(null);
                    if (update) {
                        setRefreshCounter(x => x + 1);
                    }
                    helpers.GoToTop();
                }}
                month={selectedDate.getMonth()}
                monthlyServiceToEdit={monthlyServiceToEdit}
                publicMinistryDoc={publicMinistryDoc}
                users={users}
                year={selectedDate.getFullYear()}
            />
        }

        {/* S-13 */}

        </>
    );
}
